import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {WkfSupervisionSearchResultState} from './reducer/wkf-supervision-search-result.reducer';

export const selectWkfSupervisionSearchResultFeature = createFeatureSelector<WkfSupervisionSearchResultState>(StoreKeys.WKF_SUPERVISION_SEARCH_RESULT);

export const selectWkfSupervisionSearchResultDatas = createSelector(selectWkfSupervisionSearchResultFeature, state => state.datas);

export const selectWkfSupervisionSearchResultDatasContent = createSelector(selectWkfSupervisionSearchResultDatas, state => state?.content);
